import { useState } from 'react';
import { Input } from '../Input/Input';
import { Dropdown } from '../Dropdown/Dropdown';
import { Button } from '../buttons/Button/Button';
import { CheckForm } from '../CheckForm/CheckForm';
import { Link } from '../Link/Link';
// import { ThankYouPage } from "./ThankYouPage";
import { senderCategory } from './assets';
import './form.css';
import { useSelector } from 'react-redux';

export const CTAForm = () => {
    const {
        cta_field_email_placeholder,
        cta_field_email_title,
        cta_field_message_placeholder,
        cta_field_message_title,
        cta_field_name_placeholder,
        cta_field_name_title,
        cta_field_organization_placeholder,
        cta_field_organization_title,
        cta_field_phone_placeholder,
        cta_field_phone_title,
        cta_field_sender_title,
    } = useSelector(state => state?.homepage?.data?.data) || {};

    const [agreed, setAgreed] = useState(true);

    const onAgreed = value => {
        setAgreed(value);
    };
    const handleInputChange = e => {};

    const onSubmitForm = e => {
        e.preventDefault();
    };

    return (
        <form onSubmit={onSubmitForm} className="form">
            <div className="content-form-wrapper">
                <div className="inputs-line">
                    <label>
                        <span className="body3">{cta_field_name_title}</span>
                        <Input type="text" placeholder={cta_field_name_placeholder} onChange={handleInputChange} />
                    </label>
                    <label>
                        <span className="body3">{cta_field_email_title}</span>
                        <Input type="email" placeholder={cta_field_email_placeholder} onChange={handleInputChange} />
                    </label>
                </div>
                <div className="inputs-line">
                    <label>
                        <span className="body3">{cta_field_phone_title}</span>
                        <Input type="tel" pattern="[0-9]*" placeholder={cta_field_phone_placeholder} name="phone" />
                    </label>
                    <label>
                        <span className="body3">{cta_field_organization_title}</span>
                        <Input placeholder={cta_field_organization_placeholder} />
                    </label>
                </div>
                <div className="form-dropdown">
                    <label>
                        <span className="body3">{cta_field_sender_title}</span>
                        <Dropdown options={senderCategory} />
                    </label>
                </div>
                <label>
                    <span className="body3">{cta_field_message_title}</span>
                    <textarea className="textarea" placeholder={cta_field_message_placeholder}></textarea>
                </label>
                {/* TODO api this fields */}
                <div className="submit-wrapper">
                    <div className="checkbox-wrapper">
                        <CheckForm onClick={onAgreed} checked={true}>
                            <span>I agree to the</span> <Link href="https://www.google.com">Terms of Use</Link>
                            <span> and</span> <Link href="/#">Privacy Policy</Link>
                        </CheckForm>
                    </div>
                    <div className="submit-button">
                        <Button type={`${!agreed && 'disabled'} submit`}>SUBMIT</Button>
                    </div>
                </div>
            </div>
            {/* <ThankYouPage /> */}
        </form>
    );
};
